<template>
  <pt-detection-list class="pt-detection-list__page"></pt-detection-list>
</template>

<script>
import PtDetectionList from 'cps/gene-product/pt-detection-list/withData'
export default {
  name: 'pt-detection-list__view',
  components: {
    'pt-detection-list': PtDetectionList
  }
}
</script>
